import React, { useEffect, useState } from 'react'
import { EditPage } from '@equipedigitalfloripa/ed-cms/components'
// import { EditPage } from '../components/EditPage'
import * as convenioApi from '../api/colaborador'
import { fetchItems } from '../api/gestao'

const EditConvenio = ({ edit }) => {
  const [gestoes, setGestoes] = useState([]);

  useEffect(() => {
    new Promise(async (resolve, reject) => {
      let response = await fetchItems();
      if(response.status == 200){
        let data = response.data;
        let aux = []
        data.forEach(element => {
          aux.push({ value: element._id, label: element.name })
        });
        setGestoes(aux)
      }
    })
  }, [])


  const selectedData = [
    {
      name: '_id',
      type: 'hidden',
      title: 'Id'
    },
    {
      name: "gestao",
      type: "select",
      title: "Selecione a Gestão do colaborador",
      selectOptions: gestoes,
      options: {
        populated: true
      }
    },
    {
      name: 'name',
      type: 'text',
      title: "Nome do colaborador",
      validation: {
        required: true
      },
      options: {
        maxLength: '150'
      },
    },
    {
      name: "funcao",
      type: "text",
      title: "Função do colaborador"
    },
    {
      name: "ordem",
      type: "text",
      title: "Ordem"
    },
    {
      name: 'description',
      type: 'tiny',
      title: "Pequena descrição do convenio",
    },
    
    {
      name: 'image',
      type: 'dragdrop',
      title: 'Imagem',
      options: {
        maxFiles: 1
      },
      validation: {
        required: true
      },
    },
  ]
  return (
    <EditPage
      title={edit ? "Editar convenio" : "Adicionar Serviço"}
      subtitle={edit ? "Alterando informações do convenio" : "Adicionando informações do convenio"}
      selectedData={selectedData} 
      addFunction={convenioApi.addItem}
      fetchFunction={convenioApi.fetchItem}
      editFunction={convenioApi.editItem}
      uploadFunction={convenioApi.uploadColaborador}
      edit={edit}
      url='colaborador'
    />
  )
}

export default EditConvenio
